import { api } from "./api";

export const obtenerFondos = async () => {
  const { data } = await api.get("/fondos/all");
  return data;
};
